export const SET_LAST_UPDATE_TIME = 'set_last_update_time'
export const SET_USER_INFO = 'set_user_info'
export const SET_DEVICE_SIZE = 'set_device_size'
export const SET_LANGUAGE = 'set_language'
export const SET_LANGUAGE_OBJ = 'set_language_obj'
